import { Component, h } from 'preact';
import { toDecimal, fromDecimal } from '../../../../core/decimal';
import { DummyInputEvent } from '../../../utils/dummy-input-event';


interface FormattedNumberInputProps {
  value?: number;
  onChange?: (event: any) => void;

  placeholder?: string;
  containerStyle?: any;
  inputContainerStyle?: any;
  disabled?: boolean;

  customFormatter?: (value: number) => string;

  'class'?: string,
  className?: string;
  min?: number;
  max?: number;
  type?: 'number';

  prefix?: string;
  suffix?: string;
}

interface FormattedNumberInputState {
  focused?: boolean;
}

export class FormattedNumberInput extends Component<FormattedNumberInputProps, FormattedNumberInputState> {
  constructor(props) {
    super(props);

    this.state = {
      focused: false
    };
  }

  onFocus(event) {
    this.setState({ focused: true });
  }

  onBlur(event) {
    this.setState({ focused: false });
  }
  

  onChange(event: Event) {
    const props = this.props;
    const target = event.target as HTMLInputElement;
    let value = target.value;

    if (this.state.focused && props.onChange) {
      if (isNaN(fromDecimal(target.value))) {
        value = '';
      } else {
        value = `${fromDecimal(value)}`;
      }

      const newEvent = DummyInputEvent.createWithValue(value);
      if (props.onChange) {
        props.onChange(newEvent);
      }
    }
  }

  getCurrentValue() {
    const props = this.props;

    const truthyOrZero = props.value === 0 || !!props.value;
    if (!isNaN(props.value) && truthyOrZero) {
      if (this.state.focused) {
        return `${props.value}`;
      } else if (props.customFormatter)  {
        return props.customFormatter(props.value);
      } else {
        const { prefix, suffix } = props;
        let curVal = toDecimal(props.value);

        if (curVal === 'NaN') {
          return '';
        } else {
          return `${prefix || ''}${curVal}${suffix || ''}`;
        }
      }
    } else {
      return '';
    }
  }

  getExtraContainerStyles() {
    return this.props.containerStyle || {};
  }

  getExtraInputContainerStyles() {
    return this.props.inputContainerStyle || {};
  }

  render() {
    return (
      <input type={ this.state.focused ? 'number' : 'text' }
        className={ this.props.className || this.props['class'] || '' }
        value={ this.getCurrentValue() }
        onFocus={ event => this.onFocus(event) }
        onBlur={ event => this.onBlur(event) }
        placeholder={ this.props.placeholder || '' }
        disabled={ this.props.disabled }

        onChange={ event => this.onChange(event) } />
    );
  }
}
